import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Search from "../../Components/Recherche/search";
import "./main.css";
import Resultsearch from "../../Components/Recherche/results_search/ResultDecisions/resultsearch";
import Headers from "../../Components/headers/headers";
import Footer from "../../Components/footers/footer";
import { FaCommentDots } from 'react-icons/fa';

const Main = () => {
    const [query, setQuery] = useState("");
    const navigate = useNavigate();
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        // Handle window resize for responsive adjustments
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleSearch = () => {
        if (query) {
            setLoading(true);
            try {
                setTimeout(() => {
                    setLoading(false);
                    navigate(`/allresult?query=${encodeURIComponent(query)}`);
                }, 300);
            } catch (err) {
                setLoading(false);
                setError("Une erreur s'est produite lors de la recherche. Veuillez réessayer.");
            }
        } else {
            setError("Veuillez entrer un terme de recherche");
            setTimeout(() => {
                setError(null);
            }, 3000);
        }
    };

    const handleOpenChat = () => {
        console.log("Chat icon clicked");
    };

    return (
        <div>
            <Headers />

            <div className="homepage">
                <div className="homepage-header">
                    <h1 className="homepage-title">
                        Toutes les décisions de justice, en un clic.
                    </h1>
                    <p className="homepage-subtitle">
                        Simplifiez vos recherches, renforcez vos connaissances
                    </p>
                </div>

                <div className="homepage-search">
                    <Search query={query} setQuery={setQuery} handleSearch={handleSearch} />
                </div>

                <div className="homepage-description">
                    <p>
                        La première plateforme juridique ivoirienne qui associe technologie et intelligence artificielle pour des recherches simplifiées.
                    </p>
                </div>

                {error && (
                    <div className="error-message">
                        <p>{error}</p>
                    </div>
                )}

                {loading ? (
                    <div className="loading-message">
                        <p>Chargement des résultats...</p>
                    </div>
                ) : (
                    results.length > 0 && (
                        <div className="homepage-results">
                            <Resultsearch results={results} />
                        </div>
                    )
                )}
            </div>

            {/* Chat icon in bottom right corner - matches the images */}
            <div className="chat-icon" onClick={handleOpenChat}>
                <FaCommentDots size={24} color="white" />
            </div>

            <Footer />
        </div>
    );
};

export default Main;